module.exports = ".footer {\n  padding: 20px;\n  margin-top: 40px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/componentes/layout/footer.component.scss
// module id = ./src/app/componentes/layout/footer.component.scss
// module chunks = main